var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import toast from 'react-hot-toast';
import numbro from 'numbro';
import Sheet from 'sheet-happens';
import 'sheet-happens/dist/index.css';
// @ts-ignore
import interpolator from 'natural-spline-interpolator';
// @ts-ignore
import { useBranch } from 'baobab-react/hooks';
import { useLanguage } from '@base/LanguageProvider';
import { InternalTagType, TagType, CellStatus, } from '@common/api';
import * as baobab from '@data/baobab/baobab';
import { getTagLongName } from '@data/tag/tagUtil';
import { useTagActions } from '@data/tag/tagActions';
import { useTagContext } from '@data/tag/tagContext';
import { getAccountTagFormat } from '@data/cell/cell';
import { useActiveYears } from '@data/hooks/timePoints';
import { useActiveVersions } from '@data/hooks/versions';
import { backpropApi, cellsApi, forecastApi } from '@data/rest/api';
import { isDimensionTagJsonData } from '@data/tag/types';
import { useTableTagRelationsActions } from '@data/tag/tagRelationActions';
import { useUpdateUserSettingsActions } from '@data/hooks/currentUser';
import { useDebounce } from '@hooks/useDebounce';
import useTableCells from '@hooks/useTableCells';
import { ContextMenu } from '@shared/contextmenu';
import { CustomForecastModal, ForecastProgressModal } from '@shared/finder/modals/ForecastModal';
import { LineItemModal } from '@shared/lineitems/LineItemEditor';
import { getMenuConfig } from '@shared/tablechart/contextMenuConfig';
import Manager, { default as ModalManager } from '@shared/modal/Manager';
import { startGlobalLoading, stopGlobalLoading } from '@shared/loading/globalLoading';
import { formatNumber } from '@util/formatNum';
import { dateToSerial, isExcelDateFormat, serialToDate } from '@util/number';
import { ModelColumns, NumberFormatType } from '@util/enums';
import { SelectionDiv } from '@styled/Basic';
import { FormTextInput } from '@styled/Form';
import CopyFromModal from './CopyFromModal';
import { ContextComments, ContextAddComment } from '@main/comments/ContextComments';
import { createMessageAnchorForTableCell, createMessageAnchorForTagCell, useMessageThreadsByAnchor, } from '@data/hooks/comments';
import { appColors } from '@styled/useTheme';
import { FeatureWrapper } from '../../base/FeatureWrapper';
import { getGenericUniqueTagName } from '@main/conf/tageditor/menuItems';
import { useLockRows } from '@shared/finder/useLockUnlock';
import { Confirmation } from '@shared/modal/Simple';
import { halfYearToMonthsMap, quarterToMonthsMap } from '../../util/monthsQuartersHalfYears';
import { useRootSheetRow, useSelectedSheetRow, useSheetRowActions, useSheetRowsById, } from '../../data/sheetRow/sheetRowHooks';
import { useUpdateSheetRow } from '../../data/sheetRow/sheetRowActions';
import { useAuth } from '../../providers/AuthProvider';
import { useNavigate } from 'react-router-dom';
var triangleRight = new Image();
triangleRight.src =
    'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiCgkgdmlld0JveD0iMCAwIDEwMCAxMDAiIG92ZXJmbG93PSJ2aXNpYmxlIiA+Cjxwb2x5Z29uIHBvaW50cz0iMCwwIDEwMCw1MCAwLDEwMCIgc3R5bGU9ImZpbGw6Izk5OTk5OTsiLz4KPC9zdmc+Cg==';
triangleRight.width = 10;
triangleRight.height = 10;
var triangleDown = new Image();
triangleDown.src =
    'data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCIgaGVpZ2h0PSIxMDAiDQoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBvdmVyZmxvdz0idmlzaWJsZSIgPg0KPHBvbHlnb24gcG9pbnRzPSIwLDAgMTAwLDAgNTAsMTAwIiBzdHlsZT0iZmlsbDojOTk5OTk5OyIvPg0KPC9zdmc+DQo=';
triangleDown.width = 10;
triangleDown.height = 10;
var statusIconWidth = 14;
var statusIconHeight = 14;
var cellCommentIconWidth = 10;
var cellCommentIconHeight = 10;
var faInfo = new Image();
faInfo.src =
    'data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJxdWVzdGlvbi1jaXJjbGUiIGNsYXNzPSJzdmctaW5saW5lLS1mYSBmYS1xdWVzdGlvbi1jaXJjbGUgZmEtdy0xNiIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjMmQ4NWQyIiBkPSJNNTA0IDI1NmMwIDEzNi45OTctMTExLjA0MyAyNDgtMjQ4IDI0OFM4IDM5Mi45OTcgOCAyNTZDOCAxMTkuMDgzIDExOS4wNDMgOCAyNTYgOHMyNDggMTExLjA4MyAyNDggMjQ4ek0yNjIuNjU1IDkwYy01NC40OTcgMC04OS4yNTUgMjIuOTU3LTExNi41NDkgNjMuNzU4LTMuNTM2IDUuMjg2LTIuMzUzIDEyLjQxNSAyLjcxNSAxNi4yNThsMzQuNjk5IDI2LjMxYzUuMjA1IDMuOTQ3IDEyLjYyMSAzLjAwOCAxNi42NjUtMi4xMjIgMTcuODY0LTIyLjY1OCAzMC4xMTMtMzUuNzk3IDU3LjMwMy0zNS43OTcgMjAuNDI5IDAgNDUuNjk4IDEzLjE0OCA0NS42OTggMzIuOTU4IDAgMTQuOTc2LTEyLjM2MyAyMi42NjctMzIuNTM0IDMzLjk3NkMyNDcuMTI4IDIzOC41MjggMjE2IDI1NC45NDEgMjE2IDI5NnY0YzAgNi42MjcgNS4zNzMgMTIgMTIgMTJoNTZjNi42MjcgMCAxMi01LjM3MyAxMi0xMnYtMS4zMzNjMC0yOC40NjIgODMuMTg2LTI5LjY0NyA4My4xODYtMTA2LjY2NyAwLTU4LjAwMi02MC4xNjUtMTAyLTExNi41MzEtMTAyek0yNTYgMzM4Yy0yNS4zNjUgMC00NiAyMC42MzUtNDYgNDYgMCAyNS4zNjQgMjAuNjM1IDQ2IDQ2IDQ2czQ2LTIwLjYzNiA0Ni00NmMwLTI1LjM2NS0yMC42MzUtNDYtNDYtNDZ6Ij48L3BhdGg+PC9zdmc+';
faInfo.width = statusIconWidth;
faInfo.height = statusIconHeight;
var faCheck = new Image();
faCheck.src =
    'data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJjaGVjay1jaXJjbGUiIGNsYXNzPSJzdmctaW5saW5lLS1mYSBmYS1jaGVjay1jaXJjbGUgZmEtdy0xNiIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjMGFkNjZiIiBkPSJNNTA0IDI1NmMwIDEzNi45NjctMTExLjAzMyAyNDgtMjQ4IDI0OFM4IDM5Mi45NjcgOCAyNTYgMTE5LjAzMyA4IDI1NiA4czI0OCAxMTEuMDMzIDI0OCAyNDh6TTIyNy4zMTQgMzg3LjMxNGwxODQtMTg0YzYuMjQ4LTYuMjQ4IDYuMjQ4LTE2LjM3OSAwLTIyLjYyN2wtMjIuNjI3LTIyLjYyN2MtNi4yNDgtNi4yNDktMTYuMzc5LTYuMjQ5LTIyLjYyOCAwTDIxNiAzMDguMTE4bC03MC4wNTktNzAuMDU5Yy02LjI0OC02LjI0OC0xNi4zNzktNi4yNDgtMjIuNjI4IDBsLTIyLjYyNyAyMi42MjdjLTYuMjQ4IDYuMjQ4LTYuMjQ4IDE2LjM3OSAwIDIyLjYyN2wxMDQgMTA0YzYuMjQ5IDYuMjQ5IDE2LjM3OSA2LjI0OSAyMi42MjguMDAxeiI+PC9wYXRoPjwvc3ZnPg==';
faCheck.width = statusIconWidth;
faCheck.height = statusIconHeight;
var faPlay = new Image();
faPlay.src =
    'data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJwbGF5LWNpcmNsZSIgY2xhc3M9InN2Zy1pbmxpbmUtLWZhIGZhLXBsYXktY2lyY2xlIGZhLXctMTYiIHJvbGU9ImltZyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+PHBhdGggZmlsbD0iIzc3NyIgZD0iTTI1NiA4QzExOSA4IDggMTE5IDggMjU2czExMSAyNDggMjQ4IDI0OCAyNDgtMTExIDI0OC0yNDhTMzkzIDggMjU2IDh6bTExNS43IDI3MmwtMTc2IDEwMWMtMTUuOCA4LjgtMzUuNy0yLjUtMzUuNy0yMVYxNTJjMC0xOC40IDE5LjgtMjkuOCAzNS43LTIxbDE3NiAxMDdjMTYuNCA5LjIgMTYuNCAzMi45IDAgNDJ6Ij48L3BhdGg+PC9zdmc+';
faPlay.width = statusIconWidth;
faPlay.height = statusIconHeight;
var faRejected = new Image();
faRejected.src =
    'data:image/svg+xml;base64,PHN2ZyBhcmlhLWhpZGRlbj0idHJ1ZSIgZm9jdXNhYmxlPSJmYWxzZSIgZGF0YS1wcmVmaXg9ImZhcyIgZGF0YS1pY29uPSJ0aW1lcy1jaXJjbGUiIGNsYXNzPSJzdmctaW5saW5lLS1mYSBmYS10aW1lcy1jaXJjbGUgZmEtdy0xNiIgcm9sZT0iaW1nIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1MTIgNTEyIj48cGF0aCBmaWxsPSIjZjAwIiBkPSJNMjU2IDhDMTE5IDggOCAxMTkgOCAyNTZzMTExIDI0OCAyNDggMjQ4IDI0OC0xMTEgMjQ4LTI0OFMzOTMgOCAyNTYgOHptMTIxLjYgMzEzLjFjNC43IDQuNyA0LjcgMTIuMyAwIDE3TDMzOCAzNzcuNmMtNC43IDQuNy0xMi4zIDQuNy0xNyAwTDI1NiAzMTJsLTY1LjEgNjUuNmMtNC43IDQuNy0xMi4zIDQuNy0xNyAwTDEzNC40IDMzOGMtNC43LTQuNy00LjctMTIuMyAwLTE3bDY1LjYtNjUtNjUuNi02NS4xYy00LjctNC43LTQuNy0xMi4zIDAtMTdsMzkuNi0zOS42YzQuNy00LjcgMTIuMy00LjcgMTcgMGw2NSA2NS43IDY1LjEtNjUuNmM0LjctNC43IDEyLjMtNC43IDE3IDBsMzkuNiAzOS42YzQuNyA0LjcgNC43IDEyLjMgMCAxN0wzMTIgMjU2bDY1LjYgNjUuMXoiPjwvcGF0aD48L3N2Zz4=';
faRejected.width = statusIconWidth;
faRejected.height = statusIconHeight;
var commentIconSvg = "<svg width=\"100\" height=\"100\" viewBox=\"0 0 100 100\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n  <polygon points=\"100,0 100,100 0,0\" style=\"fill:".concat(appColors.function.w500, "\" />\n</svg>");
var cellCommentIcon = new Image();
cellCommentIcon.src = 'data:image/svg+xml;base64,' + btoa(commentIconSvg);
cellCommentIcon.width = cellCommentIconWidth;
cellCommentIcon.height = cellCommentIconHeight;
function XTable(props) {
    var _this = this;
    var _a;
    var _b = useLanguage(), L = _b.L, excelLocalizedDateFormat = _b.excelLocalizedDateFormat, excelLocalizedNumberFormat = _b.excelLocalizedNumberFormat, formatLocaleDate = _b.formatLocaleDate, parseLocaleDate = _b.parseLocaleDate;
    var tagData = useTagContext().tagData;
    var sheetRowsById = useSheetRowsById();
    var createSheetRow = useSheetRowActions().createSheetRow;
    var updateSheetRow = useUpdateSheetRow();
    var _c = useTagActions(), editTag = _c.editTag, editTagJsonData = _c.editTagJsonData, createTag = _c.createTag;
    var addTableRelationConnectedTags = useTableTagRelationsActions().addTableRelationConnectedTags;
    var rootCluster = useRootSheetRow();
    var selectedSheetRow = useSelectedSheetRow();
    var activeVersions = useActiveVersions();
    var activeYears = useActiveYears();
    var selectionValue = useBranch({ selectionValue: ['state', 'modelTable', 'selectionValue'] }).selectionValue;
    var loadingInProgress = useBranch({ loadingInProgress: ['state', 'loadingInProgress'] }).loadingInProgress;
    var _d = props.modelTableData, modelTable = _d.modelTable, update = _d.update, invalidate = _d.invalidate;
    var _e = useAuth(), currentUser = _e.user, userSettings = _e.settings;
    var infoColumns = userSettings.model_table_columns;
    var isCustomComponent = useRef(false);
    var tagActions = useTagActions();
    var _f = __read(useState(null), 2), contextCommentsData = _f[0], setContextCommentsData = _f[1];
    var _g = __read(useState(null), 2), newContextCommentData = _g[0], setNewContextCommentData = _g[1];
    var _h = __read(useState(null), 2), contextMenuPosition = _h[0], setContextMenuPosition = _h[1];
    var messageThreadsByAnchor = useMessageThreadsByAnchor();
    var fileInputRef = useRef(null);
    var _j = useLockRows(), lockRows = _j.lockRows, lockRowsAndSubRows = _j.lockRowsAndSubRows;
    var navigate = useNavigate();
    var monthTagIds = useMemo(function () {
        return tagData.internalTagsMap.months.map(function (mt) { return mt.id; });
    }, [tagData]);
    var qTagIds = useMemo(function () {
        return tagData.internalTagsMap.quarters.map(function (qt) { return qt.id; });
    }, [tagData]);
    var hyTagIds = useMemo(function () {
        return tagData.internalTagsMap.halfYears.map(function (hyt) { return hyt.id; });
    }, [tagData]);
    var yearTagIds = useMemo(function () {
        return tagData.internalTagsMap.years.map(function (yt) { return yt.id; });
    }, [tagData]);
    var sheetWrapper = useRef(null);
    var _k = __read(useState({ rowStartIdx: -1, colStartIdx: -1, rowEndIdx: -1, colEndIdx: -1 }), 2), selection = _k[0], setSelection = _k[1];
    var _l = __read(useState(null), 2), description = _l[0], setDescription = _l[1];
    var tableRows = modelTable.rows;
    var colHeaders = modelTable.columnHeaders;
    var rootClusterId = rootCluster === null || rootCluster === void 0 ? void 0 : rootCluster.id;
    var initialCustomTableColsWidths = ((_a = rootCluster === null || rootCluster === void 0 ? void 0 : rootCluster.customColumns) !== null && _a !== void 0 ? _a : []).map(function (ctc) { var _a; return (_a = ctc.colWidth) !== null && _a !== void 0 ? _a : 100; });
    var _m = __read(useState(initialCustomTableColsWidths), 2), customTableColsWidths = _m[0], setCustomTableColsWidths = _m[1];
    useEffect(function () {
        setCustomTableColsWidths(initialCustomTableColsWidths);
    }, [rootClusterId]);
    var basicColTypes = ['title', 'description', 'mape', 'mase'];
    var _o = __read(useState({
        title: 300,
        description: 200,
        mape: 100,
        mase: 100,
    }), 2), basicColsWidth = _o[0], setBasicColsWidth = _o[1];
    var _p = useTableCells([100]), onCellWidthChange = _p.onCellWidthChange, onCellHeightChange = _p.onCellHeightChange, cellWidth = _p.cellWidth, cellHeight = _p.cellHeight;
    var getCellWidth = function (columnIdx) {
        var ch = colHeaders[columnIdx];
        if (!ch) {
            return 100;
        }
        if (basicColTypes.includes(ch.type)) {
            return basicColsWidth[ch.type];
        }
        else if (ch.type === ModelColumns.CUSTOM_COL ||
            ch.type === ModelColumns.TAGS ||
            ch.type === ModelColumns.NUMBER_PROPERTY ||
            ch.type === ModelColumns.TEXT_PROPERTY ||
            ch.type === ModelColumns.DATE_PROPERTY ||
            ch.type === ModelColumns.FILE_PROPERTY) {
            return typeof ch.customColIdx === 'number' && customTableColsWidths[ch.customColIdx]
                ? customTableColsWidths[ch.customColIdx]
                : 100;
        }
        else {
            var dataWidthIdx = columnIdx - (1 + infoColumns.length + customTableColsWidths.length);
            return cellWidth[dataWidthIdx] ? cellWidth[dataWidthIdx] : 100;
        }
    };
    var cellWidthChangeHandler = function (indices, newWidth) {
        var e_1, _a, _b;
        var idx = [];
        try {
            for (var indices_1 = __values(indices), indices_1_1 = indices_1.next(); !indices_1_1.done; indices_1_1 = indices_1.next()) {
                var columnIdx = indices_1_1.value;
                var ch = colHeaders[columnIdx];
                if (!ch) {
                    return;
                }
                if (basicColTypes.includes(ch.type)) {
                    setBasicColsWidth(__assign(__assign({}, basicColsWidth), (_b = {}, _b[ch.type] = newWidth, _b)));
                }
                else if (ch.type === ModelColumns.CUSTOM_COL ||
                    ch.type === ModelColumns.TAGS ||
                    ch.type === ModelColumns.NUMBER_PROPERTY ||
                    ch.type === ModelColumns.TEXT_PROPERTY ||
                    ch.type === ModelColumns.DATE_PROPERTY ||
                    ch.type === ModelColumns.FILE_PROPERTY) {
                    var newCustomTableColsWidths = __spreadArray([], __read(customTableColsWidths), false);
                    if (ch.customColIdx !== undefined) {
                        newCustomTableColsWidths[ch.customColIdx] = newWidth;
                        setCustomTableColsWidths(newCustomTableColsWidths);
                    }
                }
                else {
                    var dataWidthIdx = columnIdx - (1 + infoColumns.length + customTableColsWidths.length);
                    idx.push(dataWidthIdx);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (indices_1_1 && !indices_1_1.done && (_a = indices_1.return)) _a.call(indices_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (idx.length > 0) {
            onCellWidthChange(idx, newWidth);
        }
    };
    // debounced save custom col widths on cluster
    var debouncedCustomTableColsWidths = useDebounce(customTableColsWidths, 200);
    useEffect(function () {
        if (JSON.stringify(initialCustomTableColsWidths) !== JSON.stringify(customTableColsWidths)) {
            var rootClusterCopy = (rootCluster === null || rootCluster === void 0 ? void 0 : rootCluster.sheetRow) ? __assign({}, rootCluster.sheetRow) : null;
            var customTableCols = rootClusterCopy === null || rootClusterCopy === void 0 ? void 0 : rootClusterCopy.customColumns;
            if (rootClusterCopy && customTableCols) {
                for (var idx = 0; idx < customTableColsWidths.length; idx++) {
                    var customTableCol = customTableCols[idx];
                    var customTableColWidth = customTableColsWidths[idx];
                    if (customTableCol && customTableColWidth) {
                        customTableCol.width = customTableColWidth;
                    }
                }
                updateSheetRow.mutate(rootClusterCopy);
            }
        }
    }, [debouncedCustomTableColsWidths]);
    var _q = useUpdateUserSettingsActions(), expandCollapseCluster = _q.expandCollapseCluster, setModelTableSort = _q.setModelTableSort;
    var dataOffsetY = 0;
    var dataOffsetX = 1;
    dataOffsetX += infoColumns.length;
    var titleIdx = 0;
    var isReadOnly = function (optA, optB) {
        if (modelTable.initialLoad) {
            return true;
        }
        var x = optA;
        var y = optB;
        var tableRow = tableRows[y - dataOffsetY];
        var colIdx = x - dataOffsetX;
        var col = colHeaders[x - titleIdx];
        if (col === null || col === void 0 ? void 0 : col.isReadonly) {
            return true;
        }
        if (x === titleIdx && y <= tableRows.length) {
            return false;
        }
        if (!tableRow) {
            return true;
        }
        if (col && col.type === ModelColumns.FILE_PROPERTY) {
            return true;
        }
        if (col && col.type === ModelColumns.TAGS && x - titleIdx < tableRow.data.length) {
            return tableRow.data[colIdx].readonly;
        }
        if (colIdx >= 0 && colIdx < tableRow.data.length) {
            return tableRow.data[colIdx].readonly || tableRow.readonly;
        }
        return true;
    };
    var onChange = function (changes) { return __awaiter(_this, void 0, void 0, function () {
        var changes_1, changes_1_1, cn, newTitle, tableRow, tag, row, tag, parentId, e_2_1, changedItems, changes_2, changes_2_1, change, col, tableRow, genTag, tagJsonData, parsedDate, newValue, newValue, evald, x, y, tableRow, item, accountTagId, accTag, val, date, e_3_1;
        var e_2, _a, e_3, _b;
        var _c, _d, _e, _f, _g, _h, _j, _k;
        return __generator(this, function (_l) {
            switch (_l.label) {
                case 0:
                    if (!(((_c = changes[0]) === null || _c === void 0 ? void 0 : _c.x) === titleIdx && ((_d = changes[0]) === null || _d === void 0 ? void 0 : _d.y) <= tableRows.length + dataOffsetY)) return [3 /*break*/, 17];
                    _l.label = 1;
                case 1:
                    _l.trys.push([1, 14, 15, 16]);
                    changes_1 = __values(changes), changes_1_1 = changes_1.next();
                    _l.label = 2;
                case 2:
                    if (!!changes_1_1.done) return [3 /*break*/, 13];
                    cn = changes_1_1.value;
                    if ((_e = colHeaders[cn.y]) === null || _e === void 0 ? void 0 : _e.isReadonly) {
                        return [3 /*break*/, 12];
                    }
                    newTitle = cn.value.trim();
                    if (newTitle === '') {
                        return [2 /*return*/];
                    }
                    tableRow = tableRows[cn.y];
                    if (!tableRow) return [3 /*break*/, 8];
                    if (!tableRow.generatedTagId) return [3 /*break*/, 5];
                    tag = tagData.tagById[tableRow.generatedTagId];
                    if (!(tag && tag.name !== newTitle)) return [3 /*break*/, 4];
                    return [4 /*yield*/, editTag(__assign(__assign({}, tag), { name: newTitle }))];
                case 3:
                    _l.sent();
                    _l.label = 4;
                case 4: return [3 /*break*/, 7];
                case 5:
                    row = sheetRowsById[tableRow.objectId];
                    if (!(row && row.name !== newTitle)) return [3 /*break*/, 7];
                    return [4 /*yield*/, updateSheetRow.mutateAsync(__assign(__assign({}, row), { name: newTitle }))];
                case 6:
                    _l.sent();
                    _l.label = 7;
                case 7: return [3 /*break*/, 12];
                case 8:
                    if (!(selectedSheetRow === null || selectedSheetRow === void 0 ? void 0 : selectedSheetRow.sheetRow)) return [3 /*break*/, 12];
                    return [4 /*yield*/, tagActions.createMaterializedAccountTag(newTitle)];
                case 9:
                    tag = _l.sent();
                    if (!tag) return [3 /*break*/, 11];
                    parentId = selectedSheetRow.sheetRow.id;
                    return [4 /*yield*/, createSheetRow({
                            name: newTitle,
                            parentId: parentId,
                            readonly: selectedSheetRow.sheetRow.readonly,
                            accountTagId: tag.type === TagType.Account ? tag.id : null,
                            customColumns: [],
                            dimensionTagIds: tag.type === TagType.Dimension ? [tag.id] : [],
                            hierarchyFlatten: false,
                            hierarchyMaxDepth: 0,
                            predicate: null,
                            tableTagId: null,
                            withData: false,
                        })];
                case 10:
                    _l.sent();
                    _l.label = 11;
                case 11:
                    invalidate();
                    _l.label = 12;
                case 12:
                    changes_1_1 = changes_1.next();
                    return [3 /*break*/, 2];
                case 13: return [3 /*break*/, 16];
                case 14:
                    e_2_1 = _l.sent();
                    e_2 = { error: e_2_1 };
                    return [3 /*break*/, 16];
                case 15:
                    try {
                        if (changes_1_1 && !changes_1_1.done && (_a = changes_1.return)) _a.call(changes_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                    return [7 /*endfinally*/];
                case 16: return [3 /*break*/, 28];
                case 17:
                    changedItems = [];
                    _l.label = 18;
                case 18:
                    _l.trys.push([18, 25, 26, 27]);
                    changes_2 = __values(changes), changes_2_1 = changes_2.next();
                    _l.label = 19;
                case 19:
                    if (!!changes_2_1.done) return [3 /*break*/, 24];
                    change = changes_2_1.value;
                    col = colHeaders[change.x - titleIdx];
                    if (!col) {
                        return [3 /*break*/, 23];
                    }
                    if (!(col.type === ModelColumns.TAGS || col.isReadonly || col.type === ModelColumns.FILE_PROPERTY)) return [3 /*break*/, 20];
                    return [3 /*break*/, 23];
                case 20:
                    if (!(col.type === ModelColumns.NUMBER_PROPERTY ||
                        col.type === ModelColumns.TEXT_PROPERTY ||
                        col.type === ModelColumns.DATE_PROPERTY)) return [3 /*break*/, 22];
                    tableRow = tableRows[change.y];
                    genTag = tagData.tagById[(_f = tableRow.generatedTagId) !== null && _f !== void 0 ? _f : 0];
                    tagJsonData = { values: {} };
                    if (genTag && genTag.jsonData !== null && isDimensionTagJsonData(genTag.jsonData)) {
                        tagJsonData = genTag.jsonData;
                    }
                    if (col.type === ModelColumns.DATE_PROPERTY) {
                        tagJsonData.values[col.dataString] = change.value;
                        if (typeof change.value === 'string') {
                            parsedDate = parseLocaleDate(change.value);
                            if (parsedDate !== null) {
                                tagJsonData.values[col.dataString] = parsedDate.toISOString();
                            }
                            else {
                                toast.error(L('Error parsing date'));
                                return [3 /*break*/, 23];
                            }
                        }
                        else {
                            tagJsonData.values[col.dataString] = null;
                        }
                    }
                    else if (col.type === ModelColumns.NUMBER_PROPERTY) {
                        newValue = (_g = numbro.unformat(change.value)) !== null && _g !== void 0 ? _g : null;
                        tagJsonData.values[col.dataString] = newValue;
                    }
                    else {
                        tagJsonData.values[col.dataString] = change.value;
                    }
                    return [4 /*yield*/, editTagJsonData(genTag.id, tagJsonData)];
                case 21:
                    _l.sent();
                    return [3 /*break*/, 23];
                case 22:
                    newValue = (_h = numbro.unformat(change.value)) !== null && _h !== void 0 ? _h : null;
                    if (Number.isNaN(newValue)) {
                        if (typeof change.value === 'string') {
                            try {
                                evald = eval(change.value);
                                if (!isNaN(evald)) {
                                    newValue = evald;
                                }
                                else {
                                    newValue = null;
                                }
                            }
                            catch (e) {
                                newValue = null;
                            }
                        }
                        else {
                            newValue = null;
                        }
                    }
                    x = change.x;
                    y = change.y;
                    x = x - dataOffsetX;
                    y = y - dataOffsetY;
                    tableRow = tableRows[y];
                    if (tableRow) {
                        item = tableRow.data[x];
                        accountTagId = item.tagIds.find(function (id) { var _a, _b; return ((_b = (_a = tagData.tagById) === null || _a === void 0 ? void 0 : _a[id]) === null || _b === void 0 ? void 0 : _b.type) === TagType.Account; });
                        accTag = accountTagId ? tagData.tagById[accountTagId] : null;
                        if (item && !item.readonly && !tableRow.readonly) {
                            if (isExcelDateFormat((_j = accTag === null || accTag === void 0 ? void 0 : accTag.numberFormat) === null || _j === void 0 ? void 0 : _j.format)) {
                                val = Number(change.value);
                                if (val && !Number.isNaN(val)) {
                                    changedItems.push(__assign(__assign({}, item), { value: val }));
                                }
                                else {
                                    date = parseLocaleDate((_k = change.value) === null || _k === void 0 ? void 0 : _k.toString());
                                    if (date !== null) {
                                        changedItems.push(__assign(__assign({}, item), { value: dateToSerial(date) }));
                                    }
                                    else {
                                        changedItems.push(__assign(__assign({}, item), { value: newValue }));
                                    }
                                }
                            }
                            else {
                                changedItems.push(__assign(__assign({}, item), { value: newValue }));
                            }
                        }
                    }
                    _l.label = 23;
                case 23:
                    changes_2_1 = changes_2.next();
                    return [3 /*break*/, 19];
                case 24: return [3 /*break*/, 27];
                case 25:
                    e_3_1 = _l.sent();
                    e_3 = { error: e_3_1 };
                    return [3 /*break*/, 27];
                case 26:
                    try {
                        if (changes_2_1 && !changes_2_1.done && (_b = changes_2.return)) _b.call(changes_2);
                    }
                    finally { if (e_3) throw e_3.error; }
                    return [7 /*endfinally*/];
                case 27:
                    update(changedItems);
                    _l.label = 28;
                case 28: return [2 /*return*/];
            }
        });
    }); };
    function closeDescription() {
        setDescription(null);
    }
    useEffect(function () {
        window.addEventListener('mousedown', closeDescription);
        return function () {
            window.removeEventListener('mousedown', closeDescription);
        };
    }, [description]);
    var sourceData = function (optA, optB) {
        var _a, _b, _c, _d;
        var x = optA;
        var y = optB;
        var yy = y - dataOffsetY;
        var row = tableRows[yy];
        var col = colHeaders[x - titleIdx];
        if (!row) {
            return null;
        }
        if (x === titleIdx) {
            return row.title;
        }
        else if (col && col.type === ModelColumns.TAGS && x - titleIdx < row.data.length) {
            return ((_a = row === null || row === void 0 ? void 0 : row.data) === null || _a === void 0 ? void 0 : _a[x - dataOffsetX].tagId) || null;
        }
        else if (col &&
            (col.type === ModelColumns.NUMBER_PROPERTY ||
                col.type === ModelColumns.TEXT_PROPERTY ||
                col.type === ModelColumns.DATE_PROPERTY ||
                col.type === ModelColumns.FILE_PROPERTY) &&
            x - titleIdx < row.data.length) {
            return ((_b = row === null || row === void 0 ? void 0 : row.data) === null || _b === void 0 ? void 0 : _b[x - dataOffsetX].propertyValue) || null;
        }
        else if (x >= dataOffsetX && x < row.data.length + 1) {
            return (_d = (_c = row === null || row === void 0 ? void 0 : row.data) === null || _c === void 0 ? void 0 : _c[x - dataOffsetX]) === null || _d === void 0 ? void 0 : _d.value;
        }
        else {
            return null;
        }
    };
    var getInfoColumnText = function (x, y, row) {
        var infoColumn = colHeaders[x - titleIdx];
        switch (infoColumn.type) {
            case ModelColumns.DESCRIPTION:
                return row.tagDesc ? row.tagDesc : '';
            case ModelColumns.MAPE:
                if (!row.forecastErrors) {
                    return '';
                }
                else {
                    return "".concat(formatNumber(row.forecastErrors.mape * 100, NumberFormatType.FORMATTED) + '%');
                }
            case ModelColumns.MASE:
                if (!row.forecastErrors) {
                    return '';
                }
                else {
                    return "".concat(formatNumber(row.forecastErrors.mase, NumberFormatType.FORMATTED));
                }
            default:
                return '';
        }
    };
    var displayData = useCallback(function (optA, optB) {
        var x = optA;
        var y = optB;
        var row = tableRows[y - dataOffsetY];
        if (!row) {
            return null;
        }
        if (x === titleIdx) {
            var cellObj = {
                items: [],
            };
            var xOffset = row.depth * 15;
            if (row.canExpand) {
                cellObj.items.push({
                    x: xOffset,
                    y: -5,
                    width: 10,
                    height: 10,
                    content: row.expanded ? triangleDown : triangleRight,
                    onClick: function () {
                        expandCollapseCluster(row.path);
                    },
                });
            }
            var extraTagIds = row.versionTagId ? [row.versionTagId] : [];
            var anchor_1 = createMessageAnchorForTableCell(row.path, extraTagIds);
            var messageThreads_1 = messageThreadsByAnchor.get(anchor_1);
            if (messageThreads_1 && messageThreads_1.length > 0) {
                cellObj.items.push({
                    x: basicColsWidth.title - 30,
                    y: -10,
                    width: 10,
                    height: 10,
                    content: cellCommentIcon,
                    onClick: function (e) {
                        setContextCommentsData({
                            x: e.clientX,
                            y: e.clientY,
                            anchor: anchor_1,
                        });
                    },
                });
            }
            cellObj.items.push({
                x: xOffset + 14,
                y: 0,
                content: row.title,
                width: 0,
                height: 0,
            });
            return cellObj;
        }
        if (x < dataOffsetX && x !== titleIdx) {
            return getInfoColumnText(x, y, row);
        }
        var item = row.data[x - dataOffsetX];
        if (!item) {
            return null;
        }
        var col = colHeaders[x - titleIdx];
        if (col && col.type === ModelColumns.TAGS) {
            var cellContent_1 = item.tagName ? item.tagName : '';
            var anchor_2 = item.parentTagId !== undefined && item.tagId !== undefined && item.tagId !== null
                ? createMessageAnchorForTagCell(row.path, item.parentTagId, item.tagId)
                : '';
            var messageThreads_2 = messageThreadsByAnchor.get(anchor_2);
            if (messageThreads_2 && messageThreads_2.length > 0) {
                var cellObj = {
                    items: [],
                };
                var hw = getCellWidth(x);
                cellObj.items.push({
                    x: hw - 20,
                    y: -10,
                    width: 10,
                    height: 10,
                    content: cellCommentIcon,
                    onClick: function (e) {
                        setContextCommentsData({
                            x: e.clientX,
                            y: e.clientY,
                            anchor: anchor_2,
                        });
                    },
                });
                cellObj.items.push({
                    x: 0,
                    y: 0,
                    content: cellContent_1,
                    width: 0,
                    height: 0,
                });
                return cellObj;
            }
            return cellContent_1;
        }
        if ((col && col.type === ModelColumns.TEXT_PROPERTY) ||
            (col && col.type === ModelColumns.DATE_PROPERTY) ||
            (col && col.type === ModelColumns.FILE_PROPERTY)
        // number property is saved to value and gets handled bellow same as other number cells
        ) {
            return item.propertyValue || null;
        }
        var accountTagFormat = getAccountTagFormat(item, tagData.tagById);
        var value = item.value;
        var cellContent = "".concat(item.loading ? '◌  ' : '').concat(accountTagFormat !== undefined
            ? isExcelDateFormat(accountTagFormat)
                ? excelLocalizedDateFormat(value, accountTagFormat)
                : excelLocalizedNumberFormat(value, accountTagFormat)
            : formatNumber(value, props.numberFormatType));
        var anchor = createMessageAnchorForTableCell(row.path, item.tagIds);
        var messageThreads = messageThreadsByAnchor.get(anchor);
        if (messageThreads && messageThreads.length > 0) {
            var cellObj = {
                items: [],
            };
            cellObj.items.push({
                x: 6,
                y: -10,
                width: 10,
                height: 10,
                content: cellCommentIcon,
                onClick: function (e) {
                    setContextCommentsData({
                        x: e.clientX,
                        y: e.clientY,
                        anchor: anchor,
                    });
                },
            });
            cellObj.items.push({
                x: 0,
                y: 0,
                content: cellContent,
                width: 0,
                height: 0,
            });
            return cellObj;
        }
        return cellContent;
    }, [modelTable, props.numberFormatType, cellWidth[0], messageThreadsByAnchor]);
    var editData = function (optA, optB) {
        var _a, _b, _c, _d, _e, _f;
        var x = optA;
        var y = optB;
        var yy = y - dataOffsetY;
        var tableRow = tableRows[yy];
        if (!tableRow) {
            return '';
        }
        if (x === titleIdx) {
            if (isCustomComponent.current) {
                isCustomComponent.current = false;
            }
            var generatedName = (_b = tagData.tagById[(_a = tableRow.generatedTagId) !== null && _a !== void 0 ? _a : 0]) === null || _b === void 0 ? void 0 : _b.name;
            var rowName = (_d = (_c = sheetRowsById[tableRow.objectId]) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '';
            return generatedName ? generatedName : rowName;
        }
        var xx = x - dataOffsetX;
        if (xx >= 0 && xx < tableRow.data.length) {
            var item = tableRow.data[xx];
            var col = colHeaders[x - titleIdx];
            if (col && col.type === ModelColumns.TAGS) {
                isCustomComponent.current = true;
                return item.tagName ? item.tagName : '';
            }
            else {
                isCustomComponent.current = false;
            }
            if ((col && col.type === ModelColumns.TEXT_PROPERTY) ||
                (col && col.type === ModelColumns.DATE_PROPERTY) ||
                (col && col.type === ModelColumns.FILE_PROPERTY)
            // number property is saved to value and gets handled bellow same as other number cells
            ) {
                return item.propertyValue || '';
            }
            var value = item.value;
            var accountTagId = item.tagIds.find(function (id) { var _a, _b; return ((_b = (_a = tagData.tagById) === null || _a === void 0 ? void 0 : _a[id]) === null || _b === void 0 ? void 0 : _b.type) === TagType.Account; });
            var accTag = accountTagId ? tagData.tagById[accountTagId] : null;
            var isDate = isExcelDateFormat((_f = (_e = accTag === null || accTag === void 0 ? void 0 : accTag.numberFormat) === null || _e === void 0 ? void 0 : _e.format) !== null && _f !== void 0 ? _f : '');
            if (isDate && item.value !== null) {
                var date = serialToDate(item.value);
                if (date === null) {
                    return '';
                }
                return formatLocaleDate(date);
            }
            var formatted = typeof value === 'number' ? numbro(value).format() : '';
            return formatted;
        }
        return '';
    };
    var cellStyle = function (optA, optB) {
        var x = optA;
        var y = optB;
        var col = colHeaders[x - titleIdx];
        var tableRow = tableRows[y - dataOffsetY];
        if (!tableRow) {
            return {};
        }
        var style = {};
        var readOnlyColor = appColors.neutral.w900 + '12';
        style.fontFamily = 'Inter';
        style.fontSize = 12;
        if (tableRow.selected) {
            style.fillColor = appColors.primary.w500 + '15';
        }
        if (x === titleIdx && y === tableRows.length + dataOffsetY) {
            style.color = appColors.ui.dark;
            style.marginLeft = 20;
            return style;
        }
        if (x === titleIdx) {
            style.marginLeft = 20;
            style.color = '#333333';
            return style;
        }
        if (col && col.type === ModelColumns.TAGS) {
            style.marginLeft = 10;
            var item_1 = tableRow.data[x - dataOffsetX];
            if (!item_1) {
                return style;
            }
            if (item_1.readonly || tableRow.readonly || col.isReadonly) {
                style.fillColor = readOnlyColor;
            }
            return style;
        }
        if ((col && col.type === ModelColumns.TEXT_PROPERTY) ||
            (col && col.type === ModelColumns.DATE_PROPERTY) ||
            (col && col.type === ModelColumns.FILE_PROPERTY)
        // number property is saved to value and gets handled bellow same as other number cells
        ) {
            style.marginLeft = 10;
            var item_2 = tableRow.data[x - dataOffsetX];
            if (!item_2) {
                return style;
            }
            if (item_2.readonly || tableRow.readonly || col.isReadonly) {
                style.fillColor = readOnlyColor;
            }
            return style;
        }
        if (x < dataOffsetX) {
            style.fillColor = readOnlyColor;
            return style;
        }
        var xx = x - dataOffsetX;
        var item = tableRow.data[xx];
        if (!item) {
            return style;
        }
        if (item.readonly || tableRow.readonly) {
            style.fillColor = readOnlyColor;
        }
        if (item.status === CellStatus.CALCULATED ||
            item.status === CellStatus.TOPDOWNED ||
            item.status === CellStatus.AGGREGATED) {
            style.color = appColors.primary.w500;
        }
        if (item.status === CellStatus.TOPDOWN) {
            style.weight = '600';
        }
        if (col && col.isReadonly) {
            style.fillColor = readOnlyColor;
        }
        style.textAlign = 'right';
        return style;
    };
    var columnHeaderStyle = function (index) {
        var columnHeader = colHeaders[index];
        var style = { color: appColors.ui.dark, fontFamily: 'Inter', fontSize: 12 };
        if ((columnHeader === null || columnHeader === void 0 ? void 0 : columnHeader.type) !== ModelColumns.MONTH) {
            style.weight = 'bold';
        }
        return style;
    };
    var columnHeaders = function (index) {
        var ch = colHeaders[index];
        if (ch) {
            return L(ch.title);
        }
        else {
            return null;
        }
    };
    var isSelectionValid = function () {
        return (selection.rowStartIdx !== -1 &&
            selection.colStartIdx !== -1 &&
            selection.rowEndIdx !== -1 &&
            selection.colEndIdx !== -1);
    };
    // recalculate selection sum on selected cls change
    useEffect(function () {
        var rowStartIdx = selection.rowStartIdx, colStartIdx = selection.colStartIdx, rowEndIdx = selection.rowEndIdx, colEndIdx = selection.colEndIdx;
        var selectionValue = 0;
        for (var i = rowStartIdx; i <= rowEndIdx; i++) {
            var tableRow = tableRows[i];
            if (!tableRow) {
                continue;
            }
            for (var j = colStartIdx; j <= colEndIdx; j++) {
                var item = tableRow.data[j];
                if (!item) {
                    continue;
                }
                if (item.value && typeof item.value === 'number') {
                    selectionValue = selectionValue + item.value;
                }
            }
        }
        baobab.cursors.state
            .select('modelTable', 'selectionValue')
            .set(formatNumber(selectionValue, NumberFormatType.TWO_DECIMALS));
    }, [selectedSheetRow]);
    var onSelectionChanged = function (x1, y1, x2, y2) {
        var _a = __read([x1, y1, x2, y2], 4), colStartIdx = _a[0], rowStartIdx = _a[1], colEndIdx = _a[2], rowEndIdx = _a[3];
        colStartIdx = colStartIdx - dataOffsetX;
        rowStartIdx = rowStartIdx - dataOffsetY;
        colEndIdx = colEndIdx - dataOffsetX;
        rowEndIdx = rowEndIdx - dataOffsetY;
        var newSelection = { rowStartIdx: rowStartIdx, colStartIdx: colStartIdx, rowEndIdx: rowEndIdx, colEndIdx: colEndIdx };
        var firstCellPeriodCount = 0;
        var isMultiperiodDataSelected = false;
        var isReadonlySelected = false;
        var firstCell;
        var selectionValue = 0;
        for (var i = rowStartIdx; i <= rowEndIdx; i++) {
            var tableRow = tableRows[i];
            if (!tableRow) {
                continue;
            }
            var _loop_1 = function () {
                var item = tableRow.data[j];
                if (!item) {
                    return "continue";
                }
                firstCell = item;
                var currentCellPeriodCount = 0;
                item.tagIds.forEach(function (tId) {
                    if (monthTagIds.includes(tId)) {
                        currentCellPeriodCount = 1;
                    }
                });
                item.tagIds.forEach(function (tId) {
                    if (qTagIds.includes(tId)) {
                        currentCellPeriodCount = 3;
                    }
                });
                item.tagIds.forEach(function (tId) {
                    if (hyTagIds.includes(tId)) {
                        currentCellPeriodCount = 6;
                    }
                });
                item.tagIds.forEach(function (tId) {
                    if (yearTagIds.includes(tId)) {
                        currentCellPeriodCount = 12;
                    }
                });
                if (firstCellPeriodCount === 0) {
                    firstCellPeriodCount = currentCellPeriodCount;
                }
                if (currentCellPeriodCount !== firstCellPeriodCount) {
                    isMultiperiodDataSelected = true;
                }
                if (item.readonly) {
                    isReadonlySelected = true;
                }
                if (item.value && typeof item.value === 'number') {
                    selectionValue = selectionValue + item.value;
                }
            };
            for (var j = colStartIdx; j <= colEndIdx; j++) {
                _loop_1();
            }
        }
        if (firstCell) {
            var monthTag_1;
            var month_1 = null;
            firstCell.tagIds.forEach(function (tId) {
                if (monthTagIds.includes(tId)) {
                    monthTag_1 = tagData.internalTagsMap.months.find(function (mt) { return mt.id === tId; });
                    month_1 = monthTag_1 ? parseInt(monthTag_1.name.substring(1)) : null;
                }
            });
            if (!month_1) {
                //try to find qTags
                var qTag_1;
                firstCell.tagIds.forEach(function (tId) {
                    if (qTagIds.includes(tId)) {
                        qTag_1 = tagData.internalTagsMap.quarters.find(function (qt) { return qt.id === tId; });
                        month_1 = qTag_1 ? parseInt(qTag_1.name.substring(1)) * 3 - 2 : null;
                    }
                });
                if (!qTag_1) {
                    // try to find htTags
                    var hyTag_1;
                    firstCell.tagIds.forEach(function (tId) {
                        if (hyTagIds.includes(tId)) {
                            hyTag_1 = tagData.internalTagsMap.halfYears.find(function (hyt) { return hyt.id === tId; });
                            month_1 = hyTag_1 && hyTag_1.name === 'H1' ? 1 : 7;
                        }
                    });
                }
            }
            var yearTag_1;
            firstCell.tagIds.forEach(function (tId) {
                if (yearTagIds.includes(tId)) {
                    yearTag_1 = tagData.internalTagsMap.years.find(function (yt) { return yt.id === tId; });
                }
            });
            var year = yearTag_1 ? parseInt(yearTag_1.name.substring(1)) : null;
            if (year) {
                baobab.cursors.state.select('flowManager', 'selectedDate', props.tableKey).set({
                    month: month_1 ? month_1 : 1,
                    year: year,
                });
            }
        }
        baobab.cursors.state.select('tables', props.tableKey).set(!isReadonlySelected && !isMultiperiodDataSelected);
        baobab.cursors.state.select('tables', 'copyForNextEnabled', props.tableKey).set(!isMultiperiodDataSelected);
        baobab.cursors.state
            .select('modelTable', 'selectionValue')
            .set(formatNumber(selectionValue, NumberFormatType.TWO_DECIMALS));
        if (rowEndIdx - rowStartIdx === 0 && tableRows[rowStartIdx]) {
            baobab.cursors.state.set('selectedRowPath', tableRows[rowStartIdx].path);
        }
        if (newSelection !== selection) {
            setSelection(newSelection);
        }
    };
    var roundValuesToInt = function () {
        if (!isSelectionValid()) {
            return;
        }
        var changes = [];
        for (var i = selection.rowStartIdx; i <= selection.rowEndIdx; i++) {
            var tableRow = tableRows[i];
            if (!tableRow) {
                continue;
            }
            for (var j = selection.colStartIdx; j <= selection.colEndIdx; j++) {
                var item = tableRow.data[j];
                if (!item) {
                    continue;
                }
                changes.push(__assign(__assign({}, item), { value: Math.round(item.value || 0) }));
            }
        }
        update(changes);
    };
    var regression = function () {
        if (!isSelectionValid()) {
            return;
        }
        var changes = [];
        for (var i = selection.rowStartIdx; i <= selection.rowEndIdx; i++) {
            var tableRow = tableRows[i];
            if (!tableRow) {
                continue;
            }
            var dataset = [];
            for (var j = selection.colStartIdx; j <= selection.colEndIdx; j++) {
                var item = tableRow.data[j];
                if (!item) {
                    continue;
                }
                if (item.value !== null) {
                    dataset.push([j, item.value]);
                }
            }
            var f = interpolator(dataset);
            for (var j = selection.colStartIdx; j <= selection.colEndIdx; j++) {
                var item = tableRow.data[j];
                if (!item) {
                    continue;
                }
                if (item.readonly) {
                    continue;
                }
                changes.push(__assign(__assign({}, item), { value: f(j) }));
            }
        }
        update(changes);
    };
    var addPercentToSelection = function (percent) { return __awaiter(_this, void 0, void 0, function () {
        var changes, i, tableRow, j, item;
        return __generator(this, function (_a) {
            if (!isSelectionValid()) {
                return [2 /*return*/];
            }
            changes = [];
            for (i = selection.rowStartIdx; i <= selection.rowEndIdx; i++) {
                tableRow = tableRows[i];
                if (!tableRow) {
                    continue;
                }
                for (j = selection.colStartIdx; j <= selection.colEndIdx; j++) {
                    item = tableRow.data[j];
                    if (item.readonly || item.value === null || !item) {
                        continue;
                    }
                    changes.push(__assign(__assign({}, item), { value: (item.value * (100 + percent)) / 100 }));
                }
            }
            update(changes);
            return [2 /*return*/];
        });
    }); };
    var copyForPeriods = function (periods, previous) {
        if (!isSelectionValid()) {
            return;
        }
        var rowStartIdx = selection.rowStartIdx, rowEndIdx = selection.rowEndIdx, colStartIdx = selection.colStartIdx, colEndIdx = selection.colEndIdx;
        var step = colEndIdx - colStartIdx + 1;
        var changes = [];
        var changesRequestedPerRow = step * periods;
        var rowChanges = 0;
        for (var r = rowStartIdx; r <= rowEndIdx; r++) {
            var tableRow = tableRows[r];
            if (!tableRow) {
                continue;
            }
            var currentCol = previous ? colEndIdx - step : colStartIdx + step;
            var templateCol = previous ? colEndIdx : colStartIdx;
            var _loop_2 = function () {
                var thisItem = tableRow.data[currentCol];
                var templateItem = tableRow.data[templateCol];
                if (!templateItem || !thisItem) {
                    return "break";
                }
                var thisItemHasMonthTag = false;
                thisItem.tagIds.forEach(function (tId) {
                    if (monthTagIds.includes(tId)) {
                        thisItemHasMonthTag = true;
                    }
                });
                var templateItemHasMonthTag = false;
                templateItem.tagIds.forEach(function (tId) {
                    if (monthTagIds.includes(tId)) {
                        templateItemHasMonthTag = true;
                    }
                });
                if (!thisItemHasMonthTag || !templateItemHasMonthTag) {
                    previous ? currentCol-- : currentCol++;
                    return "continue";
                }
                if (thisItem.readonly) {
                    previous ? currentCol-- : currentCol++;
                    rowChanges++;
                    return "continue";
                }
                changes.push(__assign(__assign({}, thisItem), { value: templateItem.value }));
                previous ? currentCol-- : currentCol++;
                previous ? templateCol-- : templateCol++;
                rowChanges++;
                if (!previous && templateCol > colEndIdx) {
                    templateCol = colStartIdx;
                }
                if (previous && templateCol < colStartIdx) {
                    templateCol = colEndIdx;
                }
            };
            while (rowChanges < changesRequestedPerRow) {
                var state_1 = _loop_2();
                if (state_1 === "break")
                    break;
            }
            rowChanges = 0;
        }
        update(changes);
    };
    var copyFor12Months = function (previous) {
        var colStartIdx = selection.colStartIdx, rowStartIdx = selection.rowStartIdx, colEndIdx = selection.colEndIdx;
        var tableRow = tableRows[rowStartIdx];
        var step = colEndIdx - colStartIdx + 1;
        copyForPeriods(Math.floor(12 / step), previous);
    };
    var copyToTimeline = function (previous) {
        var colStartIdx = selection.colStartIdx, rowStartIdx = selection.rowStartIdx;
        var tableRow = tableRows[rowStartIdx];
        previous
            ? copyForPeriods(colStartIdx, previous)
            : copyForPeriods(tableRow.data.length - 1 - colStartIdx, previous);
    };
    var copyToYear = function (previous) {
        var colStartIdx = selection.colStartIdx, colEndIdx = selection.colEndIdx, rowStartIdx = selection.rowStartIdx;
        var column = tableRows[rowStartIdx].data[colStartIdx];
        var step = colEndIdx - colStartIdx + 1;
        var month = null;
        column.tagIds.forEach(function (tId) {
            if (monthTagIds.includes(tId)) {
                var monthTag = tagData.internalTagsMap.months.find(function (mt) { return mt.id === tId; });
                month = monthTag ? parseInt(monthTag === null || monthTag === void 0 ? void 0 : monthTag.name.substring(1)) : null;
            }
        });
        if (month) {
            previous
                ? copyForPeriods(Math.ceil(month / step - 1), previous)
                : copyForPeriods(Math.floor((12 - month) / step), previous);
        }
    };
    var setValue = function (newValue, random) {
        if (!isSelectionValid()) {
            return;
        }
        var changes = [];
        for (var i = selection.rowStartIdx; i <= selection.rowEndIdx; i++) {
            var tableRow = tableRows[i];
            if (!tableRow) {
                continue;
            }
            for (var j = selection.colStartIdx; j <= selection.colEndIdx; j++) {
                var item = tableRow.data[j];
                if (!item) {
                    continue;
                }
                if (item.readonly) {
                    continue;
                }
                var value = random ? Math.random() * 10000 : newValue;
                changes.push(__assign(__assign({}, item), { value: value }));
            }
        }
        update(changes);
    };
    var lockTopDownCell = function () { return __awaiter(_this, void 0, void 0, function () {
        var cellTagIds, i, tableRow, j, item, cellTagIds_1, cellTagIds_1_1, tagIds, e_4_1;
        var e_4, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!isSelectionValid()) {
                        return [2 /*return*/];
                    }
                    cellTagIds = [];
                    for (i = selection.rowStartIdx; i <= selection.rowEndIdx; i++) {
                        tableRow = tableRows[i];
                        if (!tableRow) {
                            continue;
                        }
                        for (j = selection.colStartIdx; j <= selection.colEndIdx; j++) {
                            item = tableRow.data[j];
                            if (!item) {
                                continue;
                            }
                            if (item.readonly) {
                                continue;
                            }
                            cellTagIds.push(item.tagIds);
                        }
                    }
                    startGlobalLoading();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 6, 7, 8]);
                    cellTagIds_1 = __values(cellTagIds), cellTagIds_1_1 = cellTagIds_1.next();
                    _b.label = 2;
                case 2:
                    if (!!cellTagIds_1_1.done) return [3 /*break*/, 5];
                    tagIds = cellTagIds_1_1.value;
                    return [4 /*yield*/, backpropApi.convertCellToDefault({ tagIds: tagIds })];
                case 3:
                    _b.sent();
                    _b.label = 4;
                case 4:
                    cellTagIds_1_1 = cellTagIds_1.next();
                    return [3 /*break*/, 2];
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_4_1 = _b.sent();
                    e_4 = { error: e_4_1 };
                    return [3 /*break*/, 8];
                case 7:
                    try {
                        if (cellTagIds_1_1 && !cellTagIds_1_1.done && (_a = cellTagIds_1.return)) _a.call(cellTagIds_1);
                    }
                    finally { if (e_4) throw e_4.error; }
                    return [7 /*endfinally*/];
                case 8:
                    invalidate();
                    stopGlobalLoading();
                    return [2 /*return*/];
            }
        });
    }); };
    function copyCells(command) {
        return __awaiter(this, void 0, void 0, function () {
            var sourceTagIds, targetTagIds, offset, tagsExpression, expression;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sourceTagIds = command.sourceTagIds, targetTagIds = command.targetTagIds, offset = command.offset;
                        tagsExpression = "tags(".concat(sourceTagIds.join(','), ")");
                        expression = offset === 0 ? tagsExpression : "delay(".concat(tagsExpression, ",").concat(-offset, ")");
                        return [4 /*yield*/, cellsApi.copyCells({
                                targetCells: targetTagIds,
                                sourceExpression: expression,
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    }
    function copyCellsHandler(sourceTagIds, offset) {
        return __awaiter(this, void 0, void 0, function () {
            var targetCellTagIdsByAccountTagId, _a, _b, _i, accountTagId, targetTagIds, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        targetCellTagIdsByAccountTagId = getSelectedCellsData().targetCellTagIdsByAccountTagId;
                        startGlobalLoading();
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 6, 7, 8]);
                        _a = [];
                        for (_b in targetCellTagIdsByAccountTagId)
                            _a.push(_b);
                        _i = 0;
                        _c.label = 2;
                    case 2:
                        if (!(_i < _a.length)) return [3 /*break*/, 5];
                        accountTagId = _a[_i];
                        if (!Object.prototype.hasOwnProperty.call(targetCellTagIdsByAccountTagId, accountTagId)) return [3 /*break*/, 4];
                        targetTagIds = targetCellTagIdsByAccountTagId[accountTagId];
                        if (!targetTagIds) {
                            return [3 /*break*/, 4];
                        }
                        return [4 /*yield*/, copyCells({
                                sourceTagIds: __spreadArray(__spreadArray([], __read(sourceTagIds), false), [Number(accountTagId)], false),
                                targetTagIds: targetTagIds,
                                offset: offset,
                            })];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        _i++;
                        return [3 /*break*/, 2];
                    case 5:
                        invalidate();
                        toast.success(L("Cells copied!"));
                        return [3 /*break*/, 8];
                    case 6:
                        error_1 = _c.sent();
                        toast.error(L('Failed to copy cells') + (error_1.message ? ': ' + error_1.message : ''));
                        return [3 /*break*/, 8];
                    case 7:
                        stopGlobalLoading();
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    function forecastHandler(actionData) {
        return __awaiter(this, void 0, void 0, function () {
            var targetCellTagIdsByAccountTagId, minActiveYear, maxActiveYear, forecastRange, rowTagIdsByAccountTagId, _a, _b, _c, accountTagIdString, targetCellsTagIds, accountTagId, _loop_3, targetCellsTagIds_1, targetCellsTagIds_1_1, cellTagIds, historyRange, firstEntry, _d, accountTagId, targetRowTagIds, forecastRequestDataItems, _e, _f, _g, accountTagId, targetTagIds, historyDataExpression, forecastRequestItem, response_1, responseBody, err_1;
            var e_5, _h, e_6, _j, e_7, _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        targetCellTagIdsByAccountTagId = getSelectedCellsData().targetCellTagIdsByAccountTagId;
                        if (Object.keys(targetCellTagIdsByAccountTagId).length < 1) {
                            toast.error(L('No account tag'));
                            return [2 /*return*/];
                        }
                        minActiveYear = Math.min.apply(Math, __spreadArray([], __read(activeYears), false));
                        maxActiveYear = Math.max.apply(Math, __spreadArray([], __read(activeYears), false));
                        forecastRange = {
                            from: { month: 12, year: maxActiveYear },
                            to: { month: 1, year: minActiveYear },
                        };
                        rowTagIdsByAccountTagId = new Map();
                        try {
                            for (_a = __values(Object.entries(targetCellTagIdsByAccountTagId)), _b = _a.next(); !_b.done; _b = _a.next()) {
                                _c = __read(_b.value, 2), accountTagIdString = _c[0], targetCellsTagIds = _c[1];
                                accountTagId = Number.parseInt(accountTagIdString);
                                if (Number.isNaN(accountTagId) || targetCellsTagIds === undefined) {
                                    continue;
                                }
                                _loop_3 = function (cellTagIds) {
                                    var e_8, _m;
                                    var cellMonth = null;
                                    var cellQuarter = null;
                                    var cellHalfYear = null;
                                    var cellYear = null;
                                    var rowTagIds = [];
                                    try {
                                        // go through tags of this cell
                                        for (var cellTagIds_2 = (e_8 = void 0, __values(cellTagIds)), cellTagIds_2_1 = cellTagIds_2.next(); !cellTagIds_2_1.done; cellTagIds_2_1 = cellTagIds_2.next()) {
                                            var tagId = cellTagIds_2_1.value;
                                            var tag = tagData.tagById[tagId];
                                            if (tag === undefined) {
                                                // skip tags that don't exist in context
                                                continue;
                                            }
                                            // separate month, year and other tags
                                            if (tag.internalType === InternalTagType.Month) {
                                                cellMonth = Number.parseInt(tag.name.replace('M', ''));
                                            }
                                            else if (tag.internalType === InternalTagType.Quarter) {
                                                cellQuarter = Number.parseInt(tag.name.replace('Q', ''));
                                            }
                                            else if (tag.internalType === InternalTagType.HalfYear) {
                                                cellHalfYear = Number.parseInt(tag.name.replace('H', ''));
                                            }
                                            else if (tag.internalType === InternalTagType.Year) {
                                                cellYear = Number.parseInt(tag.name.replace('Y', ''));
                                            }
                                            else if (tag.internalType !== InternalTagType.YearToDate) {
                                                // add to row everything that's not a time-based dimension (month, quarter, half-year, year, year-to-date)
                                                rowTagIds.push(tag.id);
                                            }
                                        }
                                    }
                                    catch (e_8_1) { e_8 = { error: e_8_1 }; }
                                    finally {
                                        try {
                                            if (cellTagIds_2_1 && !cellTagIds_2_1.done && (_m = cellTagIds_2.return)) _m.call(cellTagIds_2);
                                        }
                                        finally { if (e_8) throw e_8.error; }
                                    }
                                    // expand forecast range based on found tags
                                    if (cellYear !== null) {
                                        // if no months are selected, use whole year
                                        var minMonth = 1;
                                        var maxMonth = 12;
                                        if (cellMonth !== null) {
                                            // 1 month selected
                                            minMonth = cellMonth;
                                            maxMonth = cellMonth;
                                        }
                                        else if (cellQuarter !== null) {
                                            // quarter selected (3 months)
                                            var quarterMonths = quarterToMonthsMap[cellQuarter];
                                            if (quarterMonths !== undefined) {
                                                minMonth = Math.min.apply(Math, __spreadArray([], __read(quarterMonths), false));
                                                maxMonth = Math.max.apply(Math, __spreadArray([], __read(quarterMonths), false));
                                            }
                                        }
                                        else if (cellHalfYear !== null) {
                                            // halfyear selected (6 months)
                                            var halfYearMonths = halfYearToMonthsMap[cellHalfYear];
                                            if (halfYearMonths !== undefined) {
                                                minMonth = Math.min.apply(Math, __spreadArray([], __read(halfYearMonths), false));
                                                maxMonth = Math.max.apply(Math, __spreadArray([], __read(halfYearMonths), false));
                                            }
                                        }
                                        // check lower bound (min)
                                        if (cellYear < forecastRange.from.year) {
                                            forecastRange.from.year = cellYear;
                                            forecastRange.from.month = minMonth;
                                        }
                                        else if (cellYear === forecastRange.from.year && minMonth < forecastRange.from.month) {
                                            forecastRange.from.month = minMonth;
                                        }
                                        // check upper bound (max)
                                        if (cellYear > forecastRange.to.year) {
                                            forecastRange.to.year = cellYear;
                                            forecastRange.to.month = maxMonth;
                                        }
                                        else if (cellYear === forecastRange.to.year && maxMonth > forecastRange.to.month) {
                                            forecastRange.to.month = maxMonth;
                                        }
                                    }
                                    // save row tags
                                    var accountTagRows = rowTagIdsByAccountTagId.get(accountTagId);
                                    if (accountTagRows === undefined) {
                                        accountTagRows = [];
                                        rowTagIdsByAccountTagId.set(accountTagId, accountTagRows);
                                    }
                                    // check for duplicates
                                    var newRowKey = rowTagIds.join(',');
                                    if (!accountTagRows.some(function (row) { return row.join(',') === newRowKey; })) {
                                        accountTagRows.push(rowTagIds);
                                    }
                                };
                                try {
                                    // all selected cells with this account tag
                                    for (targetCellsTagIds_1 = (e_6 = void 0, __values(targetCellsTagIds)), targetCellsTagIds_1_1 = targetCellsTagIds_1.next(); !targetCellsTagIds_1_1.done; targetCellsTagIds_1_1 = targetCellsTagIds_1.next()) {
                                        cellTagIds = targetCellsTagIds_1_1.value;
                                        _loop_3(cellTagIds);
                                    }
                                }
                                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                                finally {
                                    try {
                                        if (targetCellsTagIds_1_1 && !targetCellsTagIds_1_1.done && (_j = targetCellsTagIds_1.return)) _j.call(targetCellsTagIds_1);
                                    }
                                    finally { if (e_6) throw e_6.error; }
                                }
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (_b && !_b.done && (_h = _a.return)) _h.call(_a);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                        historyRange = {
                            from: { month: 1, year: minActiveYear },
                            to: forecastRange.from.month === 1
                                ? { month: 12, year: forecastRange.from.year - 1 }
                                : { month: forecastRange.from.month - 1, year: forecastRange.from.year },
                        };
                        if (!(actionData === 'custom')) return [3 /*break*/, 1];
                        if (rowTagIdsByAccountTagId.size > 0) {
                            firstEntry = rowTagIdsByAccountTagId.entries().next();
                            _d = __read(firstEntry.value, 2), accountTagId = _d[0], targetRowTagIds = _d[1];
                            ModalManager.renderModal(React.createElement(CustomForecastModal, { targetTagIds: targetRowTagIds, accountTagId: accountTagId, historyRange: historyRange, forecastRange: forecastRange, invalidateModelTable: invalidate }));
                        }
                        else {
                            toast.error(L('No rows selected'));
                        }
                        return [3 /*break*/, 10];
                    case 1:
                        // prepare history
                        // default: entire history (start 1st month of minActiveYear, end one month before selected cells)
                        if (!activeYears.includes(historyRange.from.year)) {
                            toast.error(L('Starting year not active'));
                            return [2 /*return*/];
                        }
                        forecastRequestDataItems = [];
                        try {
                            for (_e = __values(rowTagIdsByAccountTagId.entries()), _f = _e.next(); !_f.done; _f = _e.next()) {
                                _g = __read(_f.value, 2), accountTagId = _g[0], targetTagIds = _g[1];
                                historyDataExpression = "tags(".concat(__spreadArray([accountTagId], __read(actionData.tagIds), false).join(','), ")");
                                forecastRequestItem = {
                                    historyDataExpression: historyDataExpression,
                                    targetRows: targetTagIds,
                                };
                                forecastRequestDataItems.push(forecastRequestItem);
                            }
                        }
                        catch (e_7_1) { e_7 = { error: e_7_1 }; }
                        finally {
                            try {
                                if (_f && !_f.done && (_k = _e.return)) _k.call(_e);
                            }
                            finally { if (e_7) throw e_7.error; }
                        }
                        startGlobalLoading();
                        _l.label = 2;
                    case 2:
                        _l.trys.push([2, 4, , 10]);
                        // call forecast api
                        return [4 /*yield*/, forecastApi.forecast({
                                historyRange: historyRange,
                                forecastRange: forecastRange,
                                data: forecastRequestDataItems,
                            })];
                    case 3:
                        // call forecast api
                        _l.sent();
                        stopGlobalLoading();
                        ModalManager.renderModal(React.createElement(ForecastProgressModal, { invalidateModelTable: invalidate }));
                        return [3 /*break*/, 10];
                    case 4:
                        response_1 = _l.sent();
                        stopGlobalLoading();
                        _l.label = 5;
                    case 5:
                        _l.trys.push([5, 8, , 9]);
                        if (!(typeof response_1.json === 'function')) return [3 /*break*/, 7];
                        return [4 /*yield*/, response_1.json()];
                    case 6:
                        responseBody = _l.sent();
                        if (typeof responseBody.message === 'string') {
                            toast.error(L(responseBody.message));
                        }
                        else {
                            toast.error(L('Error starting forecast'));
                        }
                        _l.label = 7;
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        err_1 = _l.sent();
                        toast.error(L('Error starting forecast'));
                        return [3 /*break*/, 9];
                    case 9: return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    }
    var handleToolbarAction = function (action, extra) {
        switch (action) {
            case 'undo':
                //undo();
                break;
            case 'redo':
                //redo();
                break;
            case 'round':
                roundValuesToInt();
                break;
            case 'regression':
                regression();
                break;
            case 'subadd_custom':
                addPercentToSelection(parseInt(extra.value));
                break;
            case 'copy_for_periods':
                copyForPeriods(parseInt(extra.value), extra.previous);
                break;
            case '12mnths':
                copyFor12Months(extra);
                break;
            case 'timeline':
                copyToTimeline(extra);
                break;
            case 'year':
                copyToYear(extra);
                break;
            case 'set_value':
                setValue(Number(extra.value), false);
                break;
            case 'random':
                setValue(0, true);
                break;
            case 'sort':
                setModelTableSort(extra);
                break;
            case 'cells_copy':
                copyCellsHandler(extra.tagIds, extra.offset);
                break;
            case 'forecast':
                forecastHandler(extra);
                break;
            case 'lock_top_down_cell':
                lockTopDownCell();
                break;
            case 'add_comment':
                initializeAddComment();
                break;
            case 'add_tag':
                createNewDimensionTag(extra.tableId, extra.row.tagInfos.map(function (ti) { return ti.id; }));
                break;
            case 'lock_selected':
                lockSelectedRows();
                break;
            case 'lock_selected_hierarchies':
                confirmLockSelectedHierarchies(extra.value);
                break;
            default:
                break;
        }
    };
    var createNewDimensionTag = function (tableId, possiblyConnectedTagIds) { return __awaiter(_this, void 0, void 0, function () {
        var tableTag, newTag, relations, relations_1, relations_1_1, relation, connections, possiblyConnectedTagIds_1, possiblyConnectedTagIds_1_1, connId, connTag, e_9_1;
        var e_9, _a, e_10, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    tableTag = tagData.tagById[tableId];
                    if (!tableTag) {
                        console.error('Cannot find table tag');
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, createTag({
                            name: getGenericUniqueTagName(tagData.tagsByLowercase, tableTag.name),
                            ParentId: tableId,
                            type: TagType.Dimension,
                        })];
                case 1:
                    newTag = _c.sent();
                    if (!newTag) {
                        return [2 /*return*/];
                    }
                    relations = tagData.relationsByTableTagId[tableId];
                    if (!relations) return [3 /*break*/, 9];
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 7, 8, 9]);
                    relations_1 = __values(relations), relations_1_1 = relations_1.next();
                    _c.label = 3;
                case 3:
                    if (!!relations_1_1.done) return [3 /*break*/, 6];
                    relation = relations_1_1.value;
                    connections = [];
                    try {
                        for (possiblyConnectedTagIds_1 = (e_10 = void 0, __values(possiblyConnectedTagIds)), possiblyConnectedTagIds_1_1 = possiblyConnectedTagIds_1.next(); !possiblyConnectedTagIds_1_1.done; possiblyConnectedTagIds_1_1 = possiblyConnectedTagIds_1.next()) {
                            connId = possiblyConnectedTagIds_1_1.value;
                            connTag = tagData.tagById[connId];
                            if (connTag && connTag.ParentId === relation.connectedTableTagId) {
                                connections.push({
                                    dimensionTagId: newTag.id,
                                    connectedDimensionTagId: connTag.id,
                                });
                            }
                        }
                    }
                    catch (e_10_1) { e_10 = { error: e_10_1 }; }
                    finally {
                        try {
                            if (possiblyConnectedTagIds_1_1 && !possiblyConnectedTagIds_1_1.done && (_b = possiblyConnectedTagIds_1.return)) _b.call(possiblyConnectedTagIds_1);
                        }
                        finally { if (e_10) throw e_10.error; }
                    }
                    return [4 /*yield*/, addTableRelationConnectedTags(relation.id, connections)];
                case 4:
                    _c.sent();
                    _c.label = 5;
                case 5:
                    relations_1_1 = relations_1.next();
                    return [3 /*break*/, 3];
                case 6: return [3 /*break*/, 9];
                case 7:
                    e_9_1 = _c.sent();
                    e_9 = { error: e_9_1 };
                    return [3 /*break*/, 9];
                case 8:
                    try {
                        if (relations_1_1 && !relations_1_1.done && (_a = relations_1.return)) _a.call(relations_1);
                    }
                    finally { if (e_9) throw e_9.error; }
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var initializeAddComment = function () {
        var tableRow = tableRows[selection.rowStartIdx];
        if (!tableRow) {
            return;
        }
        var item = tableRow ? tableRow.data[selection.colEndIdx] : null;
        var anchor;
        if (item) {
            if (item.parentTagId !== undefined) {
                if (item.tagId !== undefined && item.tagId !== null) {
                    // tag dropdown cell
                    anchor = createMessageAnchorForTagCell(tableRow.path, item.parentTagId, item.tagId);
                }
                else {
                    // cannot attach comment where item.tagId is not set
                    return;
                }
            }
            else {
                // numeric cell
                anchor = createMessageAnchorForTableCell(tableRow.path, item.tagIds);
            }
        }
        else {
            // row title
            anchor = createMessageAnchorForTableCell(tableRow.path, tableRow.versionTagId ? [tableRow.versionTagId] : []);
        }
        setNewContextCommentData({
            x: (contextMenuPosition === null || contextMenuPosition === void 0 ? void 0 : contextMenuPosition.left) || 400,
            y: (contextMenuPosition === null || contextMenuPosition === void 0 ? void 0 : contextMenuPosition.top) || 400,
            anchor: anchor,
        });
    };
    var onContextMenuOpen = function (e) {
        setContextMenuPosition({ top: e.clientY, left: e.clientX });
    };
    var openNewListItemModal = function () {
        var tableRow = tableRows[selection.rowStartIdx];
        var tableCell = tableRow.data[selection.colStartIdx];
        if (!tableRow) {
            return;
        }
        ModalManager.renderModal(React.createElement(LineItemModal, { invalidator: invalidate, targetTableCell: tableCell }));
    };
    var canAddListItem = function () {
        var colStartIdx = selection.colStartIdx, colEndIdx = selection.colEndIdx, rowStartIdx = selection.rowStartIdx, rowEndIdx = selection.rowEndIdx;
        var tableRow = tableRows[rowStartIdx];
        var item = tableRow === null || tableRow === void 0 ? void 0 : tableRow.data[colStartIdx];
        if (colEndIdx > colStartIdx || rowEndIdx > rowStartIdx) {
            return false;
        }
        if (item) {
            return !item.readonly;
        }
        return false;
    };
    var canAddComment = function () {
        if (loadingInProgress) {
            return false;
        }
        var colStartIdx = selection.colStartIdx, rowStartIdx = selection.rowStartIdx;
        if (tableRows[rowStartIdx] && colHeaders[colStartIdx + 1]) {
            return true;
        }
        return false;
    };
    var getColumn = function () {
        var colStartIdx = selection.colStartIdx;
        var col = colHeaders[colStartIdx + dataOffsetX] ? colHeaders[colStartIdx + dataOffsetX] : null;
        return col;
    };
    var getRow = function () {
        var rowStartIdx = selection.rowStartIdx;
        var row = tableRows[rowStartIdx + dataOffsetY] ? tableRows[rowStartIdx + dataOffsetY] : null;
        return row;
    };
    var getGenerated = function () {
        var rowStartIdx = selection.rowStartIdx;
        var row = tableRows[rowStartIdx + dataOffsetY] ? tableRows[rowStartIdx + dataOffsetY] : null;
        var generated = {
            tag: null,
            table: null,
        };
        var genTagId = row === null || row === void 0 ? void 0 : row.generatedTagId;
        if (genTagId) {
            generated.tag = tagData.tagById[genTagId] || null;
        }
        if (row === null || row === void 0 ? void 0 : row.generatedTableTagId) {
            generated.table = tagData.tagById[row.generatedTableTagId] || null;
        }
        return generated;
    };
    var getLockValue = function () {
        var rowStartIdx = selection.rowStartIdx, rowEndIdx = selection.rowEndIdx;
        var hasLocked = false;
        var hasUnlocked = false;
        for (var i = rowStartIdx; i <= rowEndIdx; i++) {
            var row = tableRows[i];
            if (!row) {
                continue;
            }
            var cls = sheetRowsById[row.objectId];
            if (!cls) {
                continue;
            }
            if (cls.readonly === true) {
                hasLocked = true;
            }
            else if (cls.readonly === false) {
                hasUnlocked = true;
            }
            else {
                hasUnlocked = true;
            }
        }
        if (hasLocked && hasUnlocked) {
            return null;
        }
        else {
            return hasLocked;
        }
    };
    var getVariableTopDownValue = function () {
        var row = getRow();
        var col = getColumn();
        var variableHasTopDown = (row === null || row === void 0 ? void 0 : row.accTagHasTopDown) || false;
        if (col === null || col === void 0 ? void 0 : col.accountTagId) {
            var tag = tagData.tagById[col.accountTagId];
            if (tag) {
                variableHasTopDown = tag.topDownEnabled || false;
            }
        }
        return variableHasTopDown;
    };
    var lockSelectedRows = function () {
        var rowStartIdx = selection.rowStartIdx, rowEndIdx = selection.rowEndIdx;
        var selectedRowsIds = new Set();
        for (var i = rowStartIdx; i <= rowEndIdx; i++) {
            var row = tableRows[i];
            if (row) {
                selectedRowsIds.add(row.objectId);
            }
        }
        var currentLockState = getLockValue();
        var arr = Array.from(selectedRowsIds);
        lockRows(arr, !currentLockState);
    };
    var lockSelectedHierarchies = function (value) { return __awaiter(_this, void 0, void 0, function () {
        var rowStartIdx, rowEndIdx, selectedRowsIds, i, row, arr;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rowStartIdx = selection.rowStartIdx, rowEndIdx = selection.rowEndIdx;
                    selectedRowsIds = new Set();
                    for (i = rowStartIdx; i <= rowEndIdx; i++) {
                        row = tableRows[i];
                        if (row) {
                            selectedRowsIds.add(row.objectId);
                        }
                    }
                    arr = Array.from(selectedRowsIds);
                    return [4 /*yield*/, lockRowsAndSubRows(arr, value)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var confirmLockSelectedHierarchies = function (newValue) {
        Manager.renderModal(React.createElement(Confirmation, { width: 400, title: React.createElement("span", null, L("Confirm ".concat(newValue ? 'lock' : 'unlock'))), onOk: function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            startGlobalLoading();
                            return [4 /*yield*/, lockSelectedHierarchies(newValue)];
                        case 1:
                            _a.sent();
                            stopGlobalLoading();
                            return [2 /*return*/];
                    }
                });
            }); } },
            React.createElement("span", null,
                L("Are you sure you want to ".concat(newValue ? 'lock' : 'unlock', " selected rows and its children")),
                "?")));
    };
    var editEnabled = function () {
        var colStartIdx = selection.colStartIdx, colEndIdx = selection.colEndIdx, rowStartIdx = selection.rowStartIdx, rowEndIdx = selection.rowEndIdx;
        var tableRow, tableCol, tableData;
        if (colStartIdx + dataOffsetX === titleIdx) {
            // if title col, check cluster perms
            tableRow = tableRows[rowStartIdx];
            var perms = (tableRow === null || tableRow === void 0 ? void 0 : tableRow.objectId) ? { canUpdate: true } : null;
            if (perms === null || perms === void 0 ? void 0 : perms.canUpdate) {
                return true;
            }
            else {
                return false;
            }
        }
        tableCol = colHeaders[colStartIdx + dataOffsetX];
        if (tableCol === null || tableCol === void 0 ? void 0 : tableCol.isReadonly) {
            return false;
        }
        if (!isSelectionValid())
            return false;
        for (var r = rowStartIdx; r <= rowEndIdx; r++) {
            tableRow = tableRows[r];
            if (!tableRow || tableRow.readonly) {
                return false;
            }
            for (var c = colStartIdx; c <= colEndIdx; c++) {
                tableData = tableRow.data[c];
                if (!tableData || tableData.readonly) {
                    return false;
                }
            }
        }
        return true;
    };
    var editKeys = function (optA, optB) {
        var x = optA;
        var y = optB;
        var yy = y - dataOffsetY;
        var tableRow = tableRows[yy];
        if (!tableRow) {
            return '';
        }
        if (x === titleIdx) {
            var titleKey = tableRow.path;
            return titleKey;
        }
        var xx = x - dataOffsetX;
        if (xx >= 0 && xx < tableRow.data.length) {
            var item = tableRow.data[xx];
            var col = colHeaders[x - titleIdx];
            var key = "".concat(tableRow.path, "-").concat(item.tagIds.join(','), "-").concat(col.dataString, "-").concat(col.title);
            return key;
        }
        return '';
    };
    function getSelectedCellsData() {
        var colEndIdx = selection.colEndIdx, colStartIdx = selection.colStartIdx, rowEndIdx = selection.rowEndIdx, rowStartIdx = selection.rowStartIdx;
        var accountTagIds = [];
        var targetTagIds = [];
        var targetCellTagIdsByAccountTagId = {};
        for (var r = rowStartIdx; r <= rowEndIdx; r++) {
            var row = modelTable.rows[r];
            if (row === undefined) {
                continue;
            }
            for (var c = colStartIdx; c <= colEndIdx; c++) {
                var cell = row.data[c];
                if (cell === undefined) {
                    continue;
                }
                targetTagIds.push(cell.tagIds);
                var accTagId = cell.tagIds.find(function (id) { var _a; return ((_a = tagData.tagById[id]) === null || _a === void 0 ? void 0 : _a.type) === TagType.Account; });
                if (!accTagId) {
                    continue;
                }
                if (!accountTagIds.includes(accTagId)) {
                    accountTagIds.push(accTagId);
                }
                var targetCells = targetCellTagIdsByAccountTagId[accTagId];
                if (!targetCells) {
                    targetCellTagIdsByAccountTagId[accTagId] = [cell.tagIds];
                    continue;
                }
                targetCells.push(cell.tagIds);
            }
        }
        return { targetTagIds: targetTagIds, accountTagIds: accountTagIds, targetCellTagIdsByAccountTagId: targetCellTagIdsByAccountTagId };
    }
    function openCopyFromModal() {
        var _a = getSelectedCellsData(), targetTagIds = _a.targetTagIds, accountTagIds = _a.accountTagIds;
        ModalManager.renderModal(React.createElement(CopyFromModal, { tagIdsSelection: targetTagIds, accTagId: accountTagIds === null || accountTagIds === void 0 ? void 0 : accountTagIds[0], invalidate: invalidate, copyCellsHandler: copyCells }));
    }
    return (React.createElement("div", { ref: sheetWrapper, style: { height: props.containerHeight, width: '100%', position: 'relative' } },
        React.createElement(Sheet, { onSelectionChanged: onSelectionChanged, columnHeaders: columnHeaders, columnHeaderStyle: columnHeaderStyle, cellStyle: cellStyle, editData: editData, displayData: displayData, sourceData: sourceData, cellWidth: getCellWidth, cellHeight: cellHeight, onChange: onChange, readOnly: isReadOnly, onCellWidthChange: cellWidthChangeHandler, onCellHeightChange: onCellHeightChange, sheetStyle: {
                freezeColumns: dataOffsetX,
            }, inputComponent: isCustomComponent.current
                ? function (x, y, inputProps, commitEditingCell) { return (React.createElement(CustomInput, { invalidate: invalidate, inputProps: inputProps, commitEditingCell: commitEditingCell, row: tableRows[y - dataOffsetY], col: colHeaders[x - titleIdx], dataColIdx: x - dataOffsetX })); }
                : undefined, editKeys: editKeys }),
        React.createElement("input", { ref: fileInputRef, type: "file", style: { display: 'none' } }),
        selectionValue && (React.createElement(SelectionDiv, null,
            React.createElement("span", null, 'Sum: '),
            selectionValue)),
        React.createElement(ContextMenu, { items: getMenuConfig(handleToolbarAction, openNewListItemModal, canAddListItem(), canAddComment(), getRow(), getColumn(), getGenerated(), editEnabled(), L, activeVersions, openCopyFromModal, fileInputRef, editTagJsonData, getLockValue, getVariableTopDownValue, navigate, currentUser), triggerRefs: [{ ref: sheetWrapper }], onOpen: onContextMenuOpen }),
        React.createElement(FeatureWrapper, { featureKey: "canSeeComments" },
            contextCommentsData && (React.createElement(ContextComments, { commentsData: contextCommentsData, close: function () { return setContextCommentsData(null); } })),
            newContextCommentData && selectedSheetRow ? (React.createElement(ContextAddComment, { x: newContextCommentData.x, y: newContextCommentData.y, anchor: newContextCommentData.anchor, close: function () {
                    setNewContextCommentData(null);
                    setContextCommentsData(newContextCommentData);
                } })) : null),
        description &&
            ReactDOM.createPortal(React.createElement("div", { style: {
                    position: 'absolute',
                    left: description.left,
                    top: description.top,
                    width: 120,
                    height: 120,
                    padding: 10,
                    backgroundColor: '#ddd',
                    borderStyle: 'solid',
                    borderColor: '#333',
                    borderWidth: '1px',
                } }, description.text), document.getElementById('portal'))));
}
var CustomInput = function (_a) {
    var inputProps = _a.inputProps, commitEditingCell = _a.commitEditingCell, invalidate = _a.invalidate, row = _a.row, col = _a.col, dataColIdx = _a.dataColIdx;
    var _b = __read(useState(true), 2), show = _b[0], setShow = _b[1];
    var _c = __read(useState(''), 2), searchString = _c[0], setSearchString = _c[1];
    var tagData = useTagContext().tagData;
    var sheetRowById = useSheetRowsById();
    var updateSheetRow = useUpdateSheetRow();
    var addAndRemoveTableRelationConnectedTags = useTableTagRelationsActions().addAndRemoveTableRelationConnectedTags;
    var data = row === null || row === void 0 ? void 0 : row.data[dataColIdx];
    var clickHandler = function (tag) { return __awaiter(void 0, void 0, void 0, function () {
        var generatedTagId, genTag, relations, relation, toAdd, toRemove, error_2, sheetRow, newClsTags;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    generatedTagId = row.generatedTagId ? row.generatedTagId : -1;
                    genTag = tagData.tagById[generatedTagId];
                    if (!genTag) return [3 /*break*/, 6];
                    if (tag.id === (data === null || data === void 0 ? void 0 : data.tagId)) {
                        commitEditingCell(tag.id);
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    relations = tagData.relationsByTableTagId[genTag.ParentId || 0];
                    if (!relations) {
                        return [2 /*return*/];
                    }
                    relation = relations.find(function (r) { return r.connectedTableTagId === tag.ParentId; });
                    if (!relation) {
                        return [2 /*return*/];
                    }
                    toAdd = [
                        { dimensionTagId: genTag.id, connectedDimensionTagId: tag.id },
                    ];
                    toRemove = [];
                    if ((data === null || data === void 0 ? void 0 : data.tagId) !== undefined && (data === null || data === void 0 ? void 0 : data.tagId) !== null) {
                        toRemove.push({ dimensionTagId: genTag.id, connectedDimensionTagId: data === null || data === void 0 ? void 0 : data.tagId });
                    }
                    return [4 /*yield*/, addAndRemoveTableRelationConnectedTags(relation.id, toAdd, toRemove)];
                case 2:
                    _a.sent();
                    invalidate();
                    commitEditingCell(tag.id);
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error(error_2);
                    return [3 /*break*/, 5];
                case 4:
                    setSearchString('');
                    setShow(false);
                    return [7 /*endfinally*/];
                case 5: return [3 /*break*/, 8];
                case 6:
                    sheetRow = sheetRowById[row.objectId];
                    if (!sheetRow) return [3 /*break*/, 8];
                    newClsTags = __spreadArray([], __read(sheetRow.dimensionTagIds), false);
                    if (data === null || data === void 0 ? void 0 : data.tagId) {
                        newClsTags = newClsTags === null || newClsTags === void 0 ? void 0 : newClsTags.filter(function (id) { return id !== (data === null || data === void 0 ? void 0 : data.tagId); });
                    }
                    newClsTags.push(tag.id);
                    return [4 /*yield*/, updateSheetRow.mutateAsync(__assign(__assign({}, sheetRow), { dimensionTagIds: newClsTags }))];
                case 7:
                    _a.sent();
                    setShow(false);
                    setSearchString('');
                    commitEditingCell(tag.id);
                    _a.label = 8;
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var options = useMemo(function () {
        var arr = tagData.tagsByParentId[String((col === null || col === void 0 ? void 0 : col.tagId) || null)] || [];
        if (searchString !== '') {
            arr = arr.filter(function (opt) {
                return "".concat(opt.name, " ").concat(opt.description).toLowerCase().includes(searchString.trim().toLowerCase());
            });
        }
        return arr;
    }, [tagData, col === null || col === void 0 ? void 0 : col.tagId, searchString]);
    var inputKeyHanlder = function (e) {
        if (e.keyCode === 13 && searchString !== '') {
            e.preventDefault();
            var tag = options.find(function (opt) {
                return "".concat(opt.name, " ").concat(opt.description).toLowerCase().includes(searchString.trim().toLowerCase());
            });
            if (tag) {
                return clickHandler(tag);
            }
        }
    };
    var top = inputProps.style.top;
    var height = inputProps.style.height;
    var ciTop = top && typeof top === 'number' && height && typeof height === 'number' ? top + height : 0;
    var isReadOnly = row.readonly || (data === null || data === void 0 ? void 0 : data.readonly) || col.isReadonly;
    return (React.createElement("div", { style: __assign(__assign({}, inputProps.style), { top: ciTop }) }, show && !isReadOnly ? (React.createElement("div", { style: {
            backgroundColor: '#fff',
            width: 'auto',
            minWidth: 100,
            boxShadow: '0px 4px 16px rgba(123, 145, 167, 0.15)',
        } },
        React.createElement(FormTextInput, { autoComplete: "off", autoFocus: true, type: "text", value: searchString, placeholder: inputProps.value ? inputProps.value : '', name: "search", onChange: function (e) { return setSearchString(e.target.value); }, style: { borderRadius: 0, backgroundColor: '#fff' }, onKeyUp: inputKeyHanlder }),
        options.map(function (tag) {
            return (React.createElement("div", { key: tag.id, onClick: function () { return clickHandler(tag); }, style: { background: '#fff', padding: '5px 10px', cursor: 'pointer' } }, getTagLongName(tag)));
        }))) : null));
};
export { XTable };
